import { createAction, props } from '@ngrx/store';
import { ResponseMetadata } from './models/response-metadata.model';

export const httpResponseReceived = createAction('[LIB: HTTP] (Response) Received', props<{ response: ResponseMetadata, body?: any }>());

export const cachedDataPurged = createAction('[LIB: HTTP] (Cache) Purged', props<{ referenceDate: Date }>());
